import { defaultFilterGroups, uuidSingleton } from 'components/filter/filters-next/defaults';
import { getFilterCounts } from 'components/filter/filters-next/util';
import { ConditionalOperator } from 'components/filter/types';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { FilterCacheKey } from 'types/filter-cache-key';

const useFiltersByKey = (
    key: FilterCacheKey,
    groupId: string = uuidSingleton,
    defaultOperator: ConditionalOperator = 'and',
) => {
    return useFiltersCache(state => {
        const filterGroups =
            state.filters[key]?.filterGroups ??
            defaultFilterGroups.map(group => ({
                ...group,
                innerOperator: defaultOperator,
                outerOperator: defaultOperator,
            }));

        return {
            didInit: state.filters[key]?.dirty,
            segmentId: state.filters[key]?.segmentId,
            filters: state.getRequestValuesByKey(key),
            filterGroups,
            currentGroup: filterGroups.find(f => f.id === groupId),
            ...getFilterCounts(filterGroups),
        };
    });
};

export { useFiltersByKey };
